export default from './Documents';



// WEBPACK FOOTER //
// ./src/containers/Documents/index.js